import axios from "axios";
import {openProductPopupHandler} from "./productPopup";

const updateCartItemsCount = async () => {
    let {status, data} = await axios.get(`${window.Shopify.routes.root}cart.js`);

    if(status === 200) {
        const cartItemsCountElements = [...document.querySelectorAll('.js-cart-items-count')];

        cartItemsCountElements.map(cartItemsCount => cartItemsCount.setAttribute('data-count', data.items.length));
    }
}

export const addToCartHandler = async (e, customQuantity = null) => {
    e.preventDefault();

    const form = e.currentTarget;
    const errorMsg = form.querySelector('.js-addtocart-error');
    let variantError = true;


    const formData = new FormData(form);

    for (const value of formData.values()) {
        if(value == 'noVariant') {
            variantError = false;
        }
    }
    if(customQuantity) {
        formData.set('quantity', customQuantity);
    }

    if(variantError) {
        form.setAttribute('data-state', 'loading');
        try {
            let {status} = await axios.post(`${form.action}.js`, formData);

            if (status === 200) {
                await updateCartItemsCount();

                form.setAttribute('data-state', 'done');

                if (form.hasAttribute('data-popup')) {
                    openProductPopupHandler();
                }
            }
        } catch (e) {
            console.log("ERROR!!");
            console.log(e);
            // TODO: Error message?
        }
    }else {
        console.log(errorMsg);
        errorMsg.classList.add('d-block');
        errorMsg.querySelector('.js-addtocart-error-message').innerText = 'Mislukt: Eerst eem variantje kiezen!';
    }
}
